import React, { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import * as REST from '~services/rest';
import ServerContext from '~src/serverContext';

export const validContactQuote = (quote) => quote?.policy_version === 'contact-v1' &&
  quote?.interactive_limit === 5 && quote?.initial_contacts_unlimited === true &&
  ((quote.requires_payment === false && quote.amount === 0) ||
   (quote.requires_payment === true && Number.isFinite(quote.amount) && quote.amount > 0 && /^[A-Z]{3}$/.test(quote.currency || '')));

export const ContactPricingText = ({ quote, city }) => {
  const intl = useIntl();
  const key = 'containers.city.seo.contact-price.';
  if (!validContactQuote(quote) || !intl.messages[key + 'paid'] || !intl.messages[key + 'free']) return null;
  const paid = quote.requires_payment;
  const price = paid ? intl.formatNumber(quote.amount / 100, { style: 'currency', currency: quote.currency }) : '';
  return <aside className="c-city-contact-price" aria-label={undefined}>
    <p><strong>{intl.formatMessage({ id: key + (paid ? 'paid' : 'free') }, { city, price })}</strong></p>
    <p>{intl.formatMessage({ id: key + 'messages' })}</p>
    {paid && <p className="c-city-contact-price__basis">{intl.formatMessage({ id: key + 'basis' })}</p>}
  </aside>;
};

const ContactPricing = ({ locationId, city }) => {
  const cache = useContext(ServerContext);
  const [state, setState] = useState(() => cache.get('cityContactPricing') || null);
  useEffect(() => {
    cache.del('cityContactPricing');
    let cancelled = false;
    if (!locationId) return undefined;
    REST.get({ name: 'locations', params: { 'place-id': locationId, 'contact-pricing': true }, shouldThrowError: true })
      .then(response => { if (!cancelled) setState({ locationId, quote: response?.data?.[0] }); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [locationId]);
  return <ContactPricingText quote={state?.locationId === locationId ? state.quote : null} city={city} />;
};
export default ContactPricing;
